import { Avatar, Card } from 'antd'
import { UserOutlined } from '@ant-design/icons';
import { ReactComponent as LogoutIcon } from 'resources/images/logout.svg';
import { ReactComponent as ProfilesIcon } from 'resources/images/profiles.svg';
import Button from 'components/Button';
import AuthService from 'services/AuthService';
import { AvatarImage } from './ProfileSelectionPage';
import { useNavigate } from 'react-router';

type Props = {}

export default function AccountPage({ }: Props) {

    let userData = AuthService.getUserData()
    let grade = userData.grade || "unknown"
    let favorite_book = userData.favoriteBook || "unknown"
    let favorite_hobby = userData.favoriteHobby || "unknown"
    let first_name = userData.firstName
    let last_name = userData.lastName
    let email = userData.email
    let school = userData.school?.name
    let avatar = AuthService.getAvatarURL()
    let navigate = useNavigate();

    console.log("Avatar", avatar)

    return (
        <div className='accounts-page' style={{ height: "100vh", overflow: "auto" }}>
            <div className="accounts-page-header" />
            <div className="accounts-page-body px-5 py-5">
                <h3 className='is-size-3 mb-5'>
                    <strong className='c-white'>Your Account</strong>
                </h3>
                <div className="columns">
                    <Card className='column user-card' bordered>
                        <strong className='center is-size-4 ml-3'>{first_name} {last_name}</strong>
                        <div className="columns h-100 align-items-center">
                            <div className="column">
                                <div style={{ width: 150, height: 150 }}>
                                    <AvatarImage url={avatar} />
                                </div>
                            </div>
                            <div className="column">
                                <div className="flex-column h-100" style={{ minWidth: 150 }}>
                                    <div>
                                        {/* <div className="accounts-card m-4">
                                            A
                                            <em><strong> {grade} </strong></em>
                                            grade student
                                            who loves reading
                                            <em><strong> {favorite_book} </strong></em>
                                            books and your favorite hobby is
                                            <em><strong> {favorite_hobby} </strong></em>
                                        </div> */}
                                    </div>
                                    <Button className='mt-4 w-100' onClick={() => {
                                        navigate("/profiles")
                                    }}>
                                        <ProfilesIcon className='mr-2 c-white' />
                                        Profiles
                                    </Button>
                                    <Button className='mt-4 w-100' onClick={() => AuthService.logOut()}>
                                        <LogoutIcon className='mr-2 c-white' />
                                        Logout
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <Card className='column ml-4' bordered>
                        <strong className='is-size-4 ml-3'>Details</strong>
                        <table className='table is-hoverable w-100 mb-4'>
                            <tbody>
                                <tr>
                                    <td>First Name</td>
                                    <td>{first_name}</td>
                                </tr>
                                <tr>
                                    <td>Last Name</td>
                                    <td>{last_name}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>{email}</td>
                                </tr>
                                <tr>
                                    <td>Grade</td>
                                    <td>{grade}</td>
                                </tr>
                                <tr>
                                    <td>School</td>
                                    <td>{school}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                </div>

            </div >
        </div >
    )
}